// Third-party
import React, { ReactElement } from 'react';
import classNames from 'classnames';

interface Props {
  onSelect?: (value: any) => void;
  value: any;
  label?: string;
  children?: string | ReactElement | ReactElement[];
  className?: string;
  'aria-label'?: string;
  lang?: string;
}

const SelectOption = ({ onSelect, value, label, children, className, 'aria-label': ariaLabel, lang, ...rest }: Props) => (
  <div className={classNames(className, 'select-option')} key={`select-option-${value}`} onClick={() => onSelect && onSelect(value)} lang={lang}>
    {ariaLabel && <span className="visually-hidden">{ariaLabel}</span>}
    <span aria-hidden={!!ariaLabel}>{label || children}</span>
  </div>
);

export default SelectOption;
